import {
  hasEmptySurveyPlaceholder,
  clearSurveyPlaceholderError,
} from '@/utils/editor/sanitize-template-variables';
import { useShowToast } from './useShowToast';
import { isEmailBodyEmpty } from '@/utils/emailComposition';

export const useRejection = () => {
  const toast = useShowToast();
  const validateRejectionEmailPayload = (sendRejectEmail, values: any) => {
    const rejectEmailConfig = values?.rejectEmailConfig || {};
    const subject = rejectEmailConfig?.subject || values?.subject;

    if (sendRejectEmail) {
      const from = rejectEmailConfig?.from || values?.from;
      const body = rejectEmailConfig?.body || values?.body;

      if (!from) {
        toast({ title: 'From is mandatory', status: 'error' });
        return false;
      }
      if (!subject) {
        toast({ title: 'Subject is mandatory', status: 'error' });
        return false;
      }
      if (isEmailBodyEmpty(body)) {
        toast({ title: 'Body is mandatory', status: 'error' });
        return false;
      }

      // `{{survey.link}}` in the body is the wire format, not a sign that
      // nothing was picked: `replaceSurveySpanWithPlaceholder` turns the chosen
      // survey's span back into that token on the way out, and the id travels
      // separately as `survey[ats_form_template_id]`. Reading the body alone
      // therefore rejected sends for a survey that was visibly selected and
      // already stored, which is what customers hit (ENG-3826).
      const selectedSurvey = rejectEmailConfig?.survey ?? values?.survey;
      const hasSelectedSurvey = Boolean(
        selectedSurvey?.value ?? selectedSurvey?.id
      );

      if (hasSelectedSurvey) {
        clearSurveyPlaceholderError();
      } else if (hasEmptySurveyPlaceholder(body)) {
        toast({ title: 'Please select a survey', status: 'error' });
        return false;
      }
    }
    return true;
  };

  return {
    validateRejectionEmailPayload,
  };
};
